import React from 'react';
import { AppBar, Tabs, Tab, Grid } from '@material-ui/core';
import { useDispatch } from 'react-redux';
import { PropTypes } from 'prop-types';
import { PAYMENTS_TABS } from '../../../helpers/constants';
import { setActiveTab } from '../../../store/actions/paymentsActions';
import { homeTabStyles } from './styles';

const TABS = [
  {
    label: 'Mis facturas',
    value: PAYMENTS_TABS.INBOX,
    'data-tour': 'PAYMENTS_GUIDEDTOUR_INBOX',
  },
  {
    label: 'Programadas',
    value: PAYMENTS_TABS.SCHEDULED,
  },
  {
    label: 'Pagadas',
    value: PAYMENTS_TABS.PAID,
  },
  {
    label: 'Archivadas',
    value: PAYMENTS_TABS.ARCHIVED,
    'data-tour': 'PAYMENTS_GUIDEDTOUR_ARCHIVED',
  },
];

const HomeTabs = React.memo(props => {
  const classes = homeTabStyles();
  const dispatch = useDispatch();
  const { activeTab } = props;

  const handleChange = (event, newTab) => {
    if (activeTab !== newTab) dispatch(setActiveTab(newTab));
  };

  return (
    <Grid container item className={classes.root}>
      <AppBar position="static" className={classes.appBar} elevation={0}>
        <Tabs
          value={activeTab}
          onChange={handleChange}
          indicatorColor="secondary"
          textColor="inherit"
        >
          {/* eslint-disable react/jsx-props-no-spreading */}
          {TABS.map(item => (
            <Tab className={classes.tab} key={item.value} {...item} />
          ))}
        </Tabs>
      </AppBar>
    </Grid>
  );
});

HomeTabs.defaultProps = {
  activeTab: PAYMENTS_TABS[0],
};

HomeTabs.propTypes = {
  activeTab: PropTypes.oneOf(PAYMENTS_TABS),
};

export default HomeTabs;
